import React, { JSX } from "react";
import Snackbar from "@mui/material/Snackbar";
import MuiAlert, { AlertProps } from "@mui/material/Alert";

function Alert(props: AlertProps) {
  return <MuiAlert elevation={6} variant="filled" {...props} />;
}

export default function CustomizedSnackbars(): JSX.Element {
  const [online, setOnline] = React.useState(false);
  const [offline, setOffline] = React.useState(!navigator.onLine);

  React.useEffect(() => {
    const whenOnline = () => {
      setOffline(false);
      setOnline(true);
    };
    const whenOffline = () => {
      setOffline(true);
    };
    window.addEventListener("offline", whenOffline);
    window.addEventListener("online", whenOnline);
    return () => {
      window.removeEventListener("online", whenOnline);
      window.removeEventListener("offline", whenOffline);
    };
  });

  return (
    <div style={{ width: "100%" }}>
      <Snackbar open={offline} anchorOrigin={{ vertical: "top", horizontal: "center" }}>
        <div>
          <Alert severity="warning">
            Internet connection lost. Please make sure the computer is connected to the internet.
          </Alert>
        </div>
      </Snackbar>
      <Snackbar
        open={online}
        autoHideDuration={3000}
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
        onClose={() => setOnline(false)}
      >
        <div>
          <Alert severity="success">Internet Connected</Alert>
        </div>
      </Snackbar>
    </div>
  );
}
